import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './auth.scss';
import AppIcons from '../../assets/images/icons';
import LoginForm from '../../components/forms/login.form';



const LoginPage = () => {
    const isLogin = useRef(null);

    useEffect(() => {
        const isLoginPage = isLogin.current;
        if (isLoginPage && isLoginPage.classList.contains('login-class-adder')) {
            document.body.classList.add('login-page');
        } else {
            document.body.classList.remove('login-page');
        }
        return () => {
            document.body.classList.remove('login-page');
        };
    }, []);


    return (
        <>
            <div ref={isLogin} className={`login-class-adder login-wrpx register-wrp auth-layout`}>
                <div className='auth-page-layout f-wrp'>
                    <div className={`flex-box`}>
                        <div className='form-sec-wrp' style={{ position: 'relative' }}>


                            {<div className='auth-form'>
                                <Link to={'/'} className='auth-logo'>
                                    <img src={AppIcons.logo} alt='Pnp ai Logo' />
                                </Link>
                                <br /> <br />
                                <LoginForm />
                            </div>}
                        </div>
                    </div>
                </div>
                <div className='form-img-wrp'>
                    <span>
                        <img src={AppIcons.loginBG1} alt='PnP login' />
                    </span>
                </div>
            </div>
        </>
    )
}

export default LoginPage;